import { PluginEquifaxPpsrRegistrationRequest } from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runEquifaxPpsrRegistrationRequest = (
  constructPost: ConstructPost,
  data: PluginEquifaxPpsrRegistrationRequest,
): Promise<NonPaginatedResponse<null> | undefined> =>
  constructPost<NonPaginatedResponse<null>>(
    `${PLUGIN_BASE_PATH}/equifax-ppsr-registration-request`,
    { data },
    { preventDefaultErrorToast: true },
  );
